module.exports = __webpack_public_path__ + "img/100-1.89ff3c05.svg";